import { message } from 'antd'
import { adminApi } from '~/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

export const useDeleteCourseMutation = () => {
  const queryClient = useQueryClient()
  return useMutation((courseId) => adminApi.removeCourse(courseId), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['upcoming-courses'] })
      queryClient.invalidateQueries({ queryKey: ['past-courses'] })
      message.success('Course deleted successfully')
    }
  })
}

export const useDuplicateCourseMutation = () => {
  const history = useNavigate()
  return useMutation((courseId) => adminApi.duplicateCourse(courseId), {
    onSuccess: (response) => {
      history(`/admin/courses/edit/${response.data.data.id}`)
      message.success('Course duplicated successfully')
    }
  })
}

export const useAssignCourseUser = () => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ course_id: courseId, user_id: userId }) => adminApi.assignCourseUser(courseId, userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['upcoming-courses'] })
        queryClient.invalidateQueries({ queryKey: ['past-courses'] })
        message.success('Add user successfully')
      }
    }
  )
}
